import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';

export const canUseDOM = (): boolean =>
    !!(
        // tslint:disable-next-line:no-typeof-undefined
        (typeof window !== 'undefined' && window.document && window.document.createElement)
    );

export interface ICustomWindow extends Window {
    __warranty__?: SimpleProduct;
}
